import React from 'react';
import "@/sass/header.scss";
import logo from '@/images/jr_logo.svg';
import List from './List';
import menu from 'config/menu';
import { additionalPosition } from 'components/constant/Scroller';
import { animateScroll as scroll } from 'react-scroll';

interface IState {
    showMenu: boolean,
    clickedElement: any,
    scrollPos: number,
    offset: number,
    activeMenu: string,
}

class Header extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props);
    
        this.state = {
            showMenu: false,
            clickedElement: null,
            scrollPos: 0,
            offset: 0,
            activeMenu: ''
        };



        this.showToggle = this.showToggle.bind(this)
        this.setWrapperRef = this.setWrapperRef.bind(this)
        this.handleClickOutside = this.handleClickOutside.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('scroll', this.handleScroll)
      }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('scroll', this.handleScroll)
    }

    handleClickOutside(e: any) {
        if (this.state.showMenu) {
            if (this.state.clickedElement && !this.state.clickedElement.contains(e.target)) {
                this.setState({
                    showMenu: false
                })
            }
        }
    }

    handleScroll() {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight
        const scrolled = winScroll / height

        var activeMenu = "";
        for(var i = 0; i < menu.length; i++) {
            const el = document.getElementById(menu[i].key)
            if (el) {
                if (winScroll < (el.offsetTop + additionalPosition)) {
                    break
                }
                activeMenu = menu[i].key
            }
        }

        this.setState({
            scrollPos: scrolled,
            offset: winScroll,
            activeMenu: activeMenu
        })
    }

    setWrapperRef(node: any) {
        this.setState({
            clickedElement: node
        });
    }

    showToggle() {
        this.setState((state) => ({
            showMenu: !state.showMenu
        }))
    }
    
    goToMenu(url: string) {
        const part = url.split("#");
        const menuID = part[1];
        const el = document.getElementById(menuID);
        if (el) {
            const position = el ? (el.offsetTop + additionalPosition) : 0
            scroll.scrollTo(position)
        }
    }
      
    render() {
        var navClass = {
            parent: "navbar fixed-top navbar-expand-md navbar-light nav-container",
            burger: "navbar-toggler menu-toggle"
        }
        if (this.state.showMenu) {
            navClass.burger += " active"
        }
        if (this.state.scrollPos > 0.05) {
            navClass.parent += " active"
        }
        
        return (
            <header>
                <nav className={navClass.parent} ref={this.setWrapperRef} >
                    <div className="container">
                        <div className="logo-container">    
                            <a href="/" className="navbar-brand"><img src={logo} className="app-logo"/></a>
                        </div>
                        <button onClick={this.showToggle} className={navClass.burger} type="button">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className={`navbar-collapse menu-container ${this.state.showMenu ? 'active' : ''}`} id="navbarSupportedContent">
                            <List onClick={this.goToMenu} active={this.state.activeMenu} />              
                        </div>
                    </div>
                </nav>
            </header>
        )
    }
}

export default Header